// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeen":"cn_a bho_fm bho_vv bho_xg bho_h"};